module.exports = __webpack_public_path__ + "img/landing.04a97865.png";